//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import bus from "../common/bus";
import { get, post } from '@/api/fetch.js';
import url from '@/api/serviceAPI.config.js';
export default {
  data: function data() {
    return {
      formLabelWidth: '80px',
      passwordForm: {
        oldPassword: null,
        password: null,
        passwordConfirm: null
      },
      addLoading: false,
      passwordRules: {
        oldPassword: [{
          required: true,
          message: '请输入原密码',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }],
        passwordConfirm: [{
          required: true,
          message: '请确认密码',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {},
  methods: {
    //修改密码
    resetPassword: function resetPassword() {
      var _this = this;
      this.$refs.passwordForm.validate(function (valid) {
        if (valid) {
          _this.addLoading = true;
          get(url.user.confirmUserPwd, {
            userId: sessionStorage.getItem('userId'),
            password: _this.passwordForm.oldPassword
          }).then(function (res) {
            if (res.data == 'wrong') {
              _this.addLoading = false;
              _this.$message.error('原密码错误！');
            } else {
              if (_this.passwordForm.password.length < 6) {
                _this.addLoading = false;
                _this.$message.error('密码至少为6位！');
              } else {
                if (_this.passwordForm.password === _this.passwordForm.passwordConfirm) {
                  // 创建实例时设置配置的默认值
                  var instance = axios.create();
                  // 在实例已创建后修改默认值
                  instance.defaults.headers.post['Content-Type'] = 'application/json';
                  var pm = {
                    password: _this.passwordForm.password,
                    passwordConfirm: _this.passwordForm.passwordConfirm,
                    userId: sessionStorage.getItem('userId')
                  };
                  instance.put(url.user.resetPassword, pm).then(function (result) {
                    // this.dialogAddVisible = false;
                    _this.$message({
                      message: '密码修改成功',
                      type: 'success',
                      duration: 1000
                    });
                    _this.addLoading = false;
                    _this.logout();
                  }).catch(function (err) {
                    console.log(err);
                  }).finally(function () {
                    _this.showReset = false;
                    _this.addLoading = false;
                    _this.passwordForm = {
                      oldPassword: null,
                      password: null,
                      passwordConfirm: null
                    };
                  });
                } else {
                  _this.$message.error('两次密码输入不一样！');
                  _this.addLoading = false;
                }
              }
            }
          }).catch(function (err) {
            console.log(err);
          });
        }
      });
    },
    // 退出登录
    logout: function logout() {
      var _this2 = this;
      get(url.log.logout).then(function (res) {
        localStorage.removeItem('userName');
        localStorage.removeItem('userId');
        _this2.$router.push('/login');
      }).catch(function (err) {
        console.log(err);
      });
    },
    //
    addRoleDialogHide: function addRoleDialogHide() {
      this.$emit('spot');
    }
  },
  mounted: function mounted() {}
};